export interface ICameraApp {
    Id: string;
    CameraAppType: CameraAppType;
    Name: string;
    Description: string;
    State: CameraApplicationState;
    Version: string;
    IsActive: boolean;
}

export enum CameraAppType {
    Updater,
    Telematics,
    Firmware
}

export enum CameraApplicationState {
    Beta,
    Development,
    Production
}
